<template>
    <div class="bg-wrap">
        <div>
            <Head></Head>
        </div>
        <div class="content">
            <div class="title">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/pro/title.png">
            </div>
        </div>
        <div class="pro">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/pro/pro_1_1.png">
        </div >
        <div class="pro">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/pro/pro_2_2.png">
        </div>
        <div class="pro">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/pro/pro_3_1.png">
        </div>
    </div>
</template>

<script>

    import Head from "./Head"
    export default {
        data() {
            return {
                code:this.$route.query.code,
            }
        },
        components:{
          Head
        },
        methods:{

        },
        mounted(){
            // this.$parent.$refs.audio.play();
            // let audio = document.getElementById("audio")
            // audio.style.display = "none"
            // localStorage.setItem("isOff","false")

            let time = document.getElementById("time")
            time.style.display = ""
        },
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/bg-2.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: scroll;
    }
    .content{
        /*display: flex;*/
        /*flex-direction: column;*/
        /*align-items: center;*/
        /*justify-content: center;*/
        .title{
            width: 100%;
            img{
                width: 70%;
            }
        }
    }
    .pro{
        width: 90%;
        margin: 0 auto 10px auto;
        img{
            width: 100%;
        }
    }
    .pro:last-child{
        margin-bottom: 50px;
    }



</style>